module.exports = __webpack_public_path__ + "img/aihuk_logo.c42dce8f.svg";